import { LoginSlideMeeting, LoginSlideDashboard, LoginSlideShopper } from 'assets/images';

export type LoginCarouselSlide = {
    image: string;
    title: string;
    body: string;
};

/**
 * Right-hand panel of the V2 login screen (Figma "RGM Login Page").
 * The copy is generic RGM marketing content, identical for every tenant, so it
 * lives here rather than in the per-tenant customer config.
 */
export const LOGIN_CAROUSEL_SLIDES: LoginCarouselSlide[] = [
    {
        image: LoginSlideMeeting,
        title: 'Unlock profitable growth with smarter RGM',
        body: 'Transform fragmented data into actionable insights that help your business grow revenue, margin, and market share.',
    },
    {
        image: LoginSlideDashboard,
        title: 'Spend smarter on every promotion',
        body: 'Supporting content identify what works, reduce wasted investment, and improve promotion effectiveness across brands, channels, and markets.',
    },
    {
        image: LoginSlideShopper,
        title: 'Stay ahead of market shifts',
        body: 'Track performance signals, spot emerging opportunities, and respond faster to changing customer demand and competitive pressure.',
    },
];

export const LOGIN_CAROUSEL_INTERVAL_MS = 6000;
